export type WithServerSideProps = (args: {
  [key: string]: any
  Component: React.ComponentType<any>
}) => React.ReactNode
